import { createApp } from 'vue';
import healthD1PTable from '../../../health/D1PTable.vue'
const appElements = document.querySelectorAll('.vue-health-render-d1')

Array.from(appElements).forEach(element => {
    createApp(healthD1PTable).mount(element);
});
